
import { defineComponent } from "vue";

export default defineComponent({
	name: 'LoadingIndicator',
	props: {
		loading: {
			type: Boolean,
			required: true,
		},
		size: {
			type: String,
			required: false,
			default: 'large',
		},
	},
})
